import React, { createContext, useContext, useState } from 'react';
import { themes } from '../config/themeConfig';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');

  // const toggleTheme = (newMode) => {
  //   setMode(newMode); // Accepts 'light', 'dark', 'purple', etc.
  // };
  const toggleTheme = () => {
    setMode(prevMode => (prevMode === 'light' ? 'purple' : 'light'));
  };  

  const theme = themes[mode] || themes.light;

  return (
    <ThemeContext.Provider value={{ mode, theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeContext);